export default __webpack_public_path__ + "static/media/book.9928f0ad.svg";